import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiCompass, FiStar, FiBook} = FiIcons;

const Introduction = () => {
  return (
    <section id="introduction" className="py-10 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
          className="text-center mb-8"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            ศาสตร์แห่งการเชื่อมโยงพลังตามหลักฮวงจุ้ย
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ที่มาและความสำคัญของเกาะสีชังในทางโหราศาสตร์จีน
          </p>
        </motion.div>

        {/* Image Grid */}
        <div className="grid lg:grid-cols-3 gap-8 mb-8">
          <motion.div
            initial={{opacity: 0, x: -30}}
            whileInView={{opacity: 1, x: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="relative overflow-hidden rounded-2xl shadow-xl"
          >
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752687692464-blob"
              alt="ศาลเจ้าพ่อเขาใหญ่"
              className="w-full h-[400px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </motion.div>

          <motion.div
            initial={{opacity: 0, y: 30}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8, delay: 0.2}}
            viewport={{once: true}}
            className="relative overflow-hidden rounded-2xl shadow-xl"
          >
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752687745872-blob"
              alt="พิธีกรรม"
              className="w-full h-[400px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </motion.div>

          <motion.div
            initial={{opacity: 0, x: 30}}
            whileInView={{opacity: 1, x: 0}}
            transition={{duration: 0.8, delay: 0.4}}
            viewport={{once: true}}
            className="relative overflow-hidden rounded-2xl shadow-xl"
          >
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752687758992-blob"
              alt="บรรยากาศพิธี"
              className="w-full h-[400px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </motion.div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* Content */}
          <motion.div
            initial={{opacity: 0, x: -50}}
            whileInView={{opacity: 1, x: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="space-y-6"
          >
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiCompass} className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  ตำแหน่งทางภูมิศาสตร์
                </h3>
                <p className="text-gray-600">
                  ในทางโหราศาสตร์จีนและฮวงจุ้ย เกาะสีชังถือเป็นจุดที่มีความสำคัญทางภูมิศาสตร์ ด้วยตำแหน่งที่ตั้งในอ่าวไทยซึ่งเปรียบเสมือน "หมิงถัง" หรือลานรับพลังตามหลักฮวงจุ้ย
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiStar} className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  ศาลเจ้าพ่อเขาใหญ่
                </h3>
                <p className="text-gray-600">
                  สร้างขึ้นตั้งแต่ปี พ.ศ. 2426 ตามบันทึกจารึกโบราณ เป็นสถานที่ที่ชาวจีนโพ้นทะเลให้ความเคารพนับถือ ด้วยความเชื่อในพลังของธรรมชาติและการจัดวางตามหลักฮวงจุ้ยที่สมบูรณ์
                </p>
              </div>
            </div>
          </motion.div>

          {/* Featured Image */}
          <motion.div
            initial={{opacity: 0, x: 50}}
            whileInView={{opacity: 1, x: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="relative"
          >
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752687801983-blob"
                alt="เกาะสีชัง"
                className="w-full h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Introduction;